export default __webpack_public_path__ + "static/media/footwraps_of_the_forsaken.7ee4a8e2.jpg";